var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#9299A2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.44434 10.0742V11.5554H5.92561L10.2944 7.18667L8.81311 5.7054L4.44434 10.0742ZM11.4399 6.04115C11.594 5.8871 11.594 5.63824 11.4399 5.48419L10.5156 4.55988C10.3615 4.40582 10.1127 4.40582 9.95863 4.55988L9.23577 5.28274L10.717 6.76401L11.4399 6.04115Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdited);
export default __webpack_public_path__ + "static/media/edited.70a413f4bbf007c48d09425bdb44efbb.svg";
export { ForwardRef as ReactComponent };